import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

export const StyledWrapper = styled.div`
  display: inline-flex;
  padding: 4px 8px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 4px;
  background-color: ${({label}) => (label ? commonPalette.bannerInformational : commonPalette.bannerDefault)};
  color: ${({label}) => (label ? commonPalette.feedbackInformational : commonPalette.iconDefault)};
  margin-right: 5px;
  text-overflow: elipsis;
  white-space: nowrap;
  align-self: center;
  overflow: hidden;
  @media (max-width: 800px) {
    font-size: 10px;
  }
`;
